import React, { Component } from "react";

export default class duvidas extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12 col-sm-6 col-md-6 text-alerta">
            <h2 className="mb-4">O que é o Alerta Celular ?</h2>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;O Alerta Celular é um projeto do Estado de Alagoas, por meio
              da Secretaria de Estado da Segurança Pública, que tem como intuito criar um grande
              banco de dados de aparelhos celulares dos alagoanos. A ideia do sistema também é
              coibir a ação de assaltantes. E para participar do projeto é bem simples! Basta saber
              o IMEI (Identificador Internacional de Dispositivo Móvel) de seu aparelho, que o
              número de identificação que todo celular possui na Anatel. Depois que pegar o número
              do identificador, o usuário deve registrar o aparelho na plataforma, em caso de roubo
              ou furto, e protocolar uma ocorrência informando o número de IMEI do aparelho
              cadastrado. Por conta do cadastro, o sistema identificará o cadastro e fará um alerta
              como roubado ou furtado. É justamente com esse alerta que a polícia, durante as
              abordagens e investigações, poderá identificar o seu aparelho e, consequentemente,
              devolvê-lo
            </p>
          </div>
          <div className="col-12 col-sm-6 col-md-6 duvidas mt-5">
            <h4 className="title">Além do IMEI é preciso cadastrar mais informações?</h4>
            <p className="description">
              Sim! Apesar do IMEI ser o dado mais importante para o AlertaCelular, também é
              necessário que o usuário informe o CPF do dono do dispositivo, além de um e-mail
              válido e um telefone para contato.
            </p>

            <h4 className="title">Quem terá acesso ás informações pelo usuário?</h4>
            <p className="description">
              O único órgão que poderá ter acesso ás informações é a Secretaria de Estado da
              Segurança Pública
            </p>
            <h4 className="title">
              Como posso descobrir o número do IMEI para cadastrar o meu aparelho no Sistema?
            </h4>
            <p className="description">
              Basta digitar, em seu smartphone *#06# que o código aparecerá em seu visor.
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Duvidas.js